import { Pipe, PipeTransform } from '@angular/core';
import { UserContextService } from '../../services/common/user-context.service';
import { AccessType } from '../../models/authorization';

/**
 * Pipe to check if user has required access to a permission
 * 
 * Usage examples:
 * - In ngIf: <div *ngIf="'Administration.Users.Page':'Write' | hasAccess">Edit Controls</div>
 * - In class binding: [class.disabled]="!('Dashboard.Main.Page':'Write' | hasAccess)"
 * - In ternary: {{ ('Reports.Export.Feature':'Write' | hasAccess) ? 'Export' : 'View Only' }}
 */
@Pipe({
  name: 'hasAccess',
  pure: false  // React to UserContextService changes
})
export class AccessPipe implements PipeTransform {
  constructor(private userContextService: UserContextService) {}

  transform(value: string): boolean {
    const [permissionKey, access] = value.split(':');
    
    if (!permissionKey || !access) {
      console.warn('[AccessPipe] Invalid format. Expected "permissionKey:access"', value);
      return false;
    }

    return this.userContextService.hasAccess(
      permissionKey.trim(), 
      access.trim() as AccessType
    );
  }
}
